import {LeaderboardConstants} from '../../../../shared/leaderboard_data/LeaderboardConstants'
import {LeaderboardRowData} from '../../../../shared/leaderboard_data/LeaderboardInterfaces'
import {UIDLeaderboardTableRowViewRanked} from './UIDLeaderboardTableRowViewRanked'
import {UIWLeaderboardTableController} from './UIWLeaderboardTableController'

export class UIDLeaderboardTableController extends UIWLeaderboardTableController {
    updateRankingData(rowDatas: LeaderboardRowData[], onLeaderboardUrlChange: (leaderboardUrl: string) => void) {
        this.hasReachedDataEnd = rowDatas.length !== LeaderboardConstants.maximumLeaderboardAPIRankingRangeLimit
        for(const rowData of rowDatas) {
            const tableRowView = new UIDLeaderboardTableRowViewRanked(this.tablebody, rowData, this.getRowCount(), onLeaderboardUrlChange)
            this.tableRowViews.push(tableRowView)
        }
    }
}
